import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Cutover: web.app/firebaseapp.com är gamla URL:er — alla ska träffa
// huvuddomänen så bookmarks och länkar konvergerar (och auth blir
// same-origin överallt).
const PRIMARY_HOST = 'program.stamlogen2026.w6.se';
const FALLBACK_HOSTS = new Set([
  'w6-event-manager.web.app',
  'w6-event-manager.firebaseapp.com',
]);
if (FALLBACK_HOSTS.has(window.location.host)) {
  const target = `https://${PRIMARY_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(target);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
